// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__sgfAy","playPauseIcon":"styles_playPauseIcon__5RGw-","preogressParetn":"styles_preogressParetn__VzrK0","time":"styles_time__q3CAz"};